<template>
  <div>
    <div class="project-list-w">
      <!-- No projects -->
      <div class="no-project" v-if="projectList.length === 0 && !loading">
        <div>
          <img src="../assets/files.svg" alt="blank status" width="40%" style="margin-bottom: 12px">
          <div>
            No projects found
          </div>
        </div>
      </div>
      <!-- Project List -->
      <div class="project-list" v-else-if="!loading">
        <div class="section-title">Projects</div>
        <transition-group name="list-pop" class="project-card-list" tag="div" appear before-enter="list-pop-enter" enter="project-card">
          <div class="project-card" v-for="(project,index) in projectList.filter(project => project.open)" :key="index" @click="toProjectHome(project.id)">
            <div class="last-open-date">
              <span>{{ parseDate(project.lastOpenOn) }}</span>
              <!-- <div class="status">
                <span class="circle" style="background-color: #4caf50"></span>
                <span style="color: #808080">Active</span>
              </div> -->
            </div>
            <div class="project-name">{{project.name}}</div>
            <project-status-bar :currentStage="project.status"></project-status-bar>
          </div>
        </transition-group>
      </div>

      <!-- Add project button on the desktop -->
      <transition name="desktop-add" v-if="canAdd">
        <div class="desktop-buttons" v-if="showDesktopAdd">
          <div class="desktop-add" @click="showAddProjectPop(), showDesktopAdd = false">
            <img src="../assets/add-file.svg" alt="desktop add button" width="42px">
            <div>New Project</div>
          </div>
        </div>
      </transition>

      <!-- Add project button on mobile -->
      <div class="buttons" v-if="canAdd">
        <div class="mobile-add">
          <div class="add-float-button" @click="showAddProjectPop()">
            <img src="../assets/add (3).svg" alt="add float icon" width="24px">
          </div>
        </div>
      </div>
    </div>

    <!-- Add project form pop up -->
    <transition name="pop-w-animate">
      <div class="pop-w" v-if="showAddPopW" @click="showAddPopFunc(), showAddPop = false">
      </div>
    </transition>
    <div class="pop">
      <transition name="pop-card">
        <add-project-pop class="add-pop" v-if="showAddPop" v-on:close-pop="showAddPopFunc(), showAddPop = false"></add-project-pop>
      </transition>
    </div>
  </div>
</template>

<script>
import AddProjectPop from './AddProjectPop.vue'
import ProjectStatusBar from './ProjectStatusBar.vue'

export default {
  name: 'ProjectList',
  components: { AddProjectPop, ProjectStatusBar },
  data () {
    return {
      showAddPop: false,
      showDesktopAdd: true,
      showAddPopW: false
    }
  },
  computed: {
    projectList: function () {
      return this.$store.state.projects
    },
    loading: function () {
      return this.$store.state.initializing
    },
    userPermits: function () {
      // eslint-disable-next-line no-mixed-operators
      return this.$store.getters.currentUserInfo && this.$store.getters.currentUserInfo.permits || null
    },
    canAdd: function () {
      // eslint-disable-next-line no-mixed-operators
      return this.userPermits && this.userPermits.PROJECT_CREATE || false
    }
  },
  methods: {
    parseDate: function (stamp) {
      let date = new Date(stamp)
      return date.toLocaleDateString()
    },
    showAddProjectPop: function () {
      let that = this
      setTimeout(function () {
        that.showAddPopW = true
        that.showAddPop = true
      }, 180)
    },
    showAddPopFunc: function () {
      let that = this
      setTimeout(function () {
        that.showAddPopW = false
      }, 200)
      setTimeout(function () {
        that.showDesktopAdd = true
      }, 200)
    },
    toProjectHome: async function (projectId) {
      if (!projectId) {
        console.warn('no project id found')
        return
      }
      let switchProjectResult = await this.$store.dispatch('switchProject', projectId)
      if (switchProjectResult.success) {
        this.$emit('to-project-home')
      } else {
        this.$message.error(switchProjectResult.error)
      }
    }
  }
}
</script>

<style>
input {
  font-size: 16px !important;
}
textarea {
  font-size: 16px !important;
}
.project-list-w {
  display: flex;
  box-sizing: border-box;
  padding: 16px 0 80px 0;
  /* min-height: calc(100vh - 180px); */
}
.project-list {
  width: 100%;
  box-sizing: border-box;
  padding: 16px 12%;
}

.list-pop-enter-active {
  transition: all 0.2s ease;
}
.list-pop-leave-active {
  transition: all 0.2s ease;
}
.list-pop-enter, .list-pop-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.desktop-add-enter-active {
  transition: all 0.2s ease;
}
.desktop-add-leave-active {
  transition: all 0.2s ease;
}
.desktop-add-enter, .desktop-add-leave-to {
  opacity: 0;
  transform: translateY(-50vh) scale(1.1);
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 48px;
  margin-bottom: 4px;
  margin-left: 28px;
  margin-right: 24px;
  color: #808080;
}
.buttons {
  display: none
}
.desktop-buttons {
  display: block;
  position: fixed;
  left: calc((100vw - 122px) / 2);
  bottom: -20px;
  z-index: 8;
  margin: auto;
  width: 122px;
  height: 122px;
  border-radius: 50%;
  box-sizing: border-box;
  padding: 3px;
  text-align: center;
  font-size: 14px;
  line-height: 21px;
  font-weight: 600;
  color: #333;
  background: linear-gradient(to right, #87f1fc, #73a9fa);
  overflow: hidden;
  box-shadow: 0 -2px 2px 0 #ccc, 0 2px 2px 0 #ccc;
  cursor: pointer;
}
.desktop-add {
  display: block;
  background-color: #ffffff;
  box-sizing: border-box;
  padding-top: 20px;
  width: 115px;
  height: 116px;
  border-radius: 50%;
  cursor: pointer;
}
.mobile-add {
  display: none;
  cursor: pointer;
}
.project-card {
  width: 23vw;
  margin-left: 1vw;
  margin-right: 1vw;
  margin-bottom: 2vh;
  display: inline-block;
  border-radius: 12px;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 20px;
  border: solid 1px #f0f0f0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.status {
  float: right;
  display: flex;
  align-items: center;
}
.circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
}
.project-name {
  font-size: 19px;
  line-height: 30px;
  color: #333;
  font-weight: bold;
  width: calc(23vw - 40px);
  text-transform: capitalize;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.last-open-date {
  font-size: 12px;
  line-height: 18px;
  color: #1e88e5;
  margin-bottom: 16px;
  font-weight: 500;
}
.pop-w {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1999;
  background-color: rgba(0, 0, 0, 0.5);
}

.pop-w-animate-enter-active {
  transition: all 0.2s ease;
}
.pop-w-animate-leave-active {
  transition: all 0.2s ease;
}
.pop-w-animate-enter, .pop-w-animate-leave-to {
  opacity: 0;
}

.pop {
  position: fixed;
  top: 15vh;
  left: 25vw;
  z-index: 2000;
  width: 50vw;
  margin: 0 auto 2vh auto;
  color: #333;
}
.add-pop {
  background-color: #ffffff;
  color: #333;
  border-radius: 20px;
  overflow: hidden;
}
.pop-card-enter-active {
  transition: all 0.2s ease;
}
.pop-card-leave-active {
  transition: all 0.2s ease;
}
.pop-card-enter, .pop-card-leave-to {
  opacity: 0;
  width: 200px;
  height: 200px;
  margin: auto;
  border-radius: 50%;
  background-color: #ffffff;
  color: #ffffff !important;
  overflow: hidden;
}
.no-project {
  width: 70vw;
  height: 70vw;
  max-width: 300px;
  max-height: 300px;
  border-radius: 50%;
  background-color: #f5f5f5;
  color: #cccccc;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  margin-top: 10vh;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (max-width: 991px) {
  .add-float-button {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    box-sizing: border-box;
    padding: 16px;
    box-shadow: 0 6px 10px 0 #cccccc;
    background-color: #ffffff;
  }
  .project-list-w {
    display: block;
    margin-bottom: 24px;
  }
  .project-list {
    width: 100%;
    padding: 0 16px;
  }
  .project-card {
    width: calc(50vw - 32px);
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 20px;
    display: inline-block;
  }
  .project-name {
    width: calc(50vw - 72px);
  }
  .buttons {
    display: block;
    position: fixed;
    bottom: 20px;
    right: 16px;
    z-index: 8;
    width: auto;
    box-sizing: border-box;
    padding-top: 24px;
    text-align: center;
  }
  .desktop-buttons {
    display: none;
  }
  .desktop-add {
    display: none;
  }
  .mobile-add {
    display: inline-block
  }
  .pop {
    width: 75vw;
    left: 12.5vw;
  }
}

@media screen and (max-width: 500px) {
  .project-list-w {
    padding: 4px 0 16px 0;
  }
  .project-card {
    width: calc(100vw - 32px);
    margin-left: 0;
    margin-bottom: 12px;
    display: inline-block;
  }
  .section-title {
    margin-left: 20px;
    margin-right: 20px;
  }
  .project-name {
    width: calc(90vw - 40px);
  }
  .pop {
    width: 90vw;
    left: 5vw;
  }
  .desktop-buttons {
    display: none;
  }
  .desktop-add {
    display: none;
  }
  .mobile-add {
    display: inline-block
  }
}
</style>
